import { OrgBrandingSchema } from "./branding.schemas.js";
import { z } from "zod";
//#region src/branding-sync.schemas.ts
/**
* CP→DP branding-sync contract (seam S4).
*
* Body of the DP `POST /internal/branding-sync` endpoint (mTLS-gated, like its
* `/internal/*` siblings): CP pushes the resolved canonical branding record for
* ONE org so the DP can write its `auth.organizations.branding` replica
* (DECISIONS D1/D11). The body's `orgId` is the CP-trusted write target; the DP
* writer validates uuid + slug shape and sets org context from `orgId`. Types
* are co-located with the schema.
*/
/** Body of DP `POST /internal/branding-sync` — CP pushes the resolved record for one org. */
const BrandingSyncRequestSchema = z.object({
	orgId: z.string().uuid(),
	orgSlug: z.string().min(2).max(63),
	branding: OrgBrandingSchema
}).strict();
const BRANDING_SYNC_ROUTE = "/internal/branding-sync";
//#endregion
export { BRANDING_SYNC_ROUTE, BrandingSyncRequestSchema };

//# sourceMappingURL=branding-sync.schemas.js.map